import { Link } from '@tanstack/router'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import useCommonEmblaCarousel from '../../hooks/useCommonEmblaCarousel'
import useDimensions from '../../hooks/useDimensions'
import useImageSize from '../../hooks/useImageSize'
import { useBoundStore } from '../../store/store'
import classNames from '../../utils/classNames'
import Icon from '../icon'

const PlatformCards = () => {
  const [emblaRef] = useCommonEmblaCarousel()
  const pending_bind = useBoundStore(state => state.user.pending_bind)
  const setIsPendingDepositVisible = useBoundStore(
    state => state.common.setIsPendingDepositVisible,
  )
  const { isDesktop } = useDimensions()
  const { t } = useTranslation('homeV2')
  const imageSize = useImageSize()

  const CARDS = [
    {
      title: t('betting-sports'),
      subtitle: t('favorite-sports'),
      icon: <Icon id="sports-circle-logo" width="98" height="98" fill="#fff" />,
      gradientColor: '#7BFFA7',
      route: +pending_bind === 0 || +pending_bind === 2 ? undefined : '/sports',
      onRouteClick: () => {
        if (+pending_bind === 0 || +pending_bind === 2)
          setIsPendingDepositVisible(true)
      },
    },
    {
      title: t('roulette'),
      subtitle: t('dexterity'),
      icon: <Icon id="casino-circle-logo" width="99" height="98" fill="#fff" />,
      gradientColor: '#ff7bac',
      route: '/casino',
      onRouteClick: () => null,
    },
  ] as const

  const cards = useMemo(
    () =>
      CARDS.map((card, index) => (
        <div
          key={index}
          className={classNames(
            'relative overflow-hidden h-[388px] w-full flex items-end justify-center pb-[29px] px-12 py-0 rounded-[30px] xl:before:left-[-52%]',
            index === 0
              ? 'bg-[linear-gradient(_150.33deg,#34ae18_2.86%,#20ad15_19.94%,#65d851_47%,#38af18_47.07%,#1fad14_72.6%,#43af1a_80.63%_)]'
              : index === 1
              ? 'bg-[linear-gradient(_150.33deg,#e22c42_2.86%,#e63346_19.94%,#f95365_46.59%,#e53045_46.6%,#e93748_72.6%,#e83647_80.63%_)]'
              : // index 2
                'bg-[linear-gradient(_150.33deg,#15b3fd_2.86%,#14b5fd_19.94%,#58cfff_46.59%,#12bcfe_46.67%,#15b3fd_72.6%,#16b0fc_80.63%_)]',
            !isDesktop && 'embla__slide',
          )}>
          <div className="absolute w-full top-0">
            {/* <CardGradientSvg stopColor={card.gradientColor} /> */}
          </div>
          <div className="flex flex-col items-center z-[1]">
            {card.icon}
            <h3 className="text-[28px] font-Geometr706-BlkCn-BT text-white text-center uppercase mt-5">
              {card.title}
            </h3>
            <p className="text-[15px] text-white text-center mt-3">
              {card.subtitle}
            </p>
            <button
              className="w-full h-[50px] flex justify-center items-center bg-white mt-6 rounded-sm"
              onClick={card.onRouteClick}>
              <Link
                className={classNames(
                  'text-xs font-Syncopate-Bold text-center uppercase',
                  index === 0
                    ? 'text-[#32ae17]'
                    : index === 1
                    ? 'text-[#e93748]'
                    : 'text-[#14b4fd]',
                )}
                to={card.route}>
                {t('play-now')}
              </Link>
            </button>
          </div>
        </div>
      )),
    [t],
  )

  return (
    <div className="mt-[70px] mb-6 px-6 py-0 xl:mb-9">
      <div className="xl:max-w-[1000px] xl:grid xl:gap-[55px] xl:grid-cols-[250px_1fr] xl:items-center xl:mx-auto xl:my-0">
        <div>
          <h2 className="text-[15px] font-Geometr706-BlkCn-BT text-yellow text-center uppercase xl:text-left xl:text-xl">
            {t('bets')}
          </h2>
          <h2 className="text-3xl font-Geometr706-BlkCn-BT text-txt text-center uppercase mt-2 xl:text-left xl:text-[35px]">
            {t('more-options')}
            <br /> {t('more-fun')}
          </h2>
        </div>
        <p className="text-[15px] text-txt text-center mt-4 xl:text-left">
          {t('select-over')}
        </p>
      </div>
      <div className="relative mt-6 pt-0 pb-3 px-3 xl:max-w-screen-xl xl:grid xl:grid-cols-[repeat(2,1fr)] xl:gap-4 xl:mt-9 xl:mb-0 xl:mx-auto">
        {isDesktop ? (
          cards
        ) : (
          <div className="embla" ref={emblaRef}>
            <div className="embla__container">{cards}</div>
          </div>
        )}
        <img
          className="absolute w-[90px] aspect-[247_/_493] -left-6 top-[51%] xl:w-[200px] xl:left-[-140px] xl:z-[2] xl:top-[20%]"
          src={imageSize('coin-hat')}
          alt="Mascot"
        />
      </div>
    </div>
  )
}

export default PlatformCards
